import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environments'

@Injectable({
  providedIn: 'root'
})
export class MainService {


  constructor(private http: HttpClient , private toastr: ToastrService) { }

  // all gats
  allGats(){
    return this.http.get(`${environment.baseUrl}/gates/`)
  }

  gateByType(){
    return this.http.get(`${environment.baseUrl}/types/?name=Gate`)
  }

  geateBygateType(id:any){
    return this.http.get(`${environment.baseUrl}/gates/gate_types?gate_type=${id}`)
  }


  // toastr 

  SuccessToast(massage:string) {
    this.toastr.success(massage,'Greate' , {
      timeOut: 3000,
    });
  }

  erorrToast(massage:string){
    this.toastr.error(massage ,'Opss !!', {
      timeOut: 3000,
    });
  }

}
